import React from 'react';
import tinycolor from 'tinycolor2';
import { getRankChartLegendLabel } from '../rankChartLegend';

export const shouldUseWidePrintLegendItems = (layoutId, weightCount) => {
  return layoutId === 'landscape' && weightCount === 3;
};

export const shouldUseUnrestrictedPrintLegendItems = (layoutId, weightCount) => {
  return layoutId === 'landscape' && weightCount < 3;
};

const RankChartPrintLegend = ({ keys = [], layoutId }) => {
  if (keys.length === 0) {
    return <div className="rank-chart-print-legend rank-chart-print-legend-empty">No weighted scale categories configured.</div>;
  }

  return (
    <div
      className={`rank-chart-print-legend${shouldUseWidePrintLegendItems(layoutId, keys.length) ? ' rank-chart-print-legend--wide-items' : ''}${
        shouldUseUnrestrictedPrintLegendItems(layoutId, keys.length) ? ' rank-chart-print-legend--unrestricted-items' : ''
      }`}
      aria-label="Chart legend"
    >
      {keys.map((key) => {
        const legendLabel = getRankChartLegendLabel(key);
        return (
          <div
            className="rank-chart-print-legend-item"
            key={key.pk_EvaluationQuestionWeight}
            style={{
              backgroundColor: key.color,
              borderColor: key.color,
              color: tinycolor(key.color).isLight() ? '#3a3a3a' : 'white',
            }}
          >
            {legendLabel}
          </div>
        );
      })}
    </div>
  );
};

export default RankChartPrintLegend;
